<template>
  <path pid="0" d="M4 18h14a1 1 0 010 2H4a1 1 0 010-2zM4 6h18a1 1 0 010 2H4a1 1 0 010-2zM4 10h14a1 1 0 010 2H4a1 1 0 010-2zM4 14h18a1 1 0 010 2H4a1 1 0 010-2z"/>
</template>
